import React, { FunctionComponent } from "react"
import { Controller, FormProvider, useForm } from "react-hook-form"
import { countryList } from "../../api/Countries"
import FormInput from "../../components/Form/Inputs/FormInput"
import SelectInput from "../../components/Form/Select/Select"
import { iArtistQuery } from "../../definitions/Artists"
import { iChangeType } from "../../definitions/interfaces"
import { isAdmin } from "../../helpers/isAdmin"

interface iProps {
  setQuery: (data: iArtistQuery) => void
  query: iArtistQuery
}

const ArtistsFilters: FunctionComponent<iProps> = ({ setQuery, query }) => {
  const onChange = ({ name, value }: iChangeType) => {
    setQuery({ [name]: value })
  }

  const methods = useForm({ defaultValues: query })

  return (
    <div className={`filters`}>
      <h2>Filters</h2>
      <div className="filters-form">
        <FormProvider {...methods}>
          <FormInput
            onChange={onChange}
            autoComplete="off"
            name="name"
            placeholder="Search by name..."
          />
          {/* <FormInput
            onChange={onChange}
            autoComplete="off"
            name="country"
            placeholder="Search by country..."
          /> */}
          <Controller
            name="country"
            control={methods.control}
            render={({ value }) => (
              <SelectInput
                name="country"
                options={countryList}
                placeholder="Filter by country..."
                isClearable={true}
                value={value}
                onChange={(value) => {
                  onChange({ name: "country", value })
                }}
              />
            )}
          />
          {isAdmin() && (
            <FormInput
              autoComplete="off"
              name="public"
              label="Show Public"
              type="checkbox"
              onChange={onChange}
            />
          )}
        </FormProvider>
      </div>
    </div>
  )
}

export default ArtistsFilters
